import { render, staticRenderFns } from "./DrawDetails.vue?vue&type=template&id=7e35875e&scoped=true"
import script from "./DrawDetails.vue?vue&type=script&lang=js"
export * from "./DrawDetails.vue?vue&type=script&lang=js"
import style0 from "./DrawDetails.vue?vue&type=style&index=0&id=7e35875e&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e35875e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/build/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7e35875e')) {
      api.createRecord('7e35875e', component.options)
    } else {
      api.reload('7e35875e', component.options)
    }
    module.hot.accept("./DrawDetails.vue?vue&type=template&id=7e35875e&scoped=true", function () {
      api.rerender('7e35875e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/DrawDetails.vue"
export default component.exports